<accordion [isAnimated]="true" *ngFor="let form of getFormsAsFormGroupArray(documentsForm.controls)">
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class="fa fa-info"></i>&nbsp;<b>{{form.value.id}}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i
        class='fa fa-folder-open'></i>&nbsp;{{form.value.description}}
    </span>

    <form [formGroup]="form">
      <div class="row form-group" *ngFor="let file of getFileForms(form); index as idx;">
        <label class="col-sm-3 col-md-2 col-form-label" [attr.for]="getId(file,form.value.id,idx)">
          <b>{{ getDescription(file,form.value.id,idx) }}</b>
          <!-- <span class="text-danger" *ngIf="file.isRequired">*</span> -->
        </label>
        <div class="col-sm-8 col-md-4" *ngIf="getTakePhotoFlag(file,form.value.id,idx)!='true'">
          <input type="file" [id]="getId(file,form.value.id,idx)"
            (change)="onFileChange($event,idx, file, form.value.id)" [disabled]="disabled">
          <label [ngClass]="{'bg-success': isUploaded(file,form.value.id,idx),'custom-file-label mb-2':true}"
            [attr.for]="getId(file,form.value.id,idx)">{{getFilename(file,form.value.id,idx)}}</label>
        </div>
        <div class="col-sm-2 col-md-2">
          <i *ngIf="getTakePhotoFlag(file,form.value.id,idx)=='true'"
            class="fa fa-camera font-3xl mt-1 mr-3 pointer i-hover-primary"
            (click)="showDialogToTakePhoto(file,form.value.id,idx)"></i>
          <i class="fa fa-eye font-3xl mt-1 mr-3 pointer i-hover-primary"
            (click)="previewFile(file,form.value.id,idx)"></i>
          <i class="fa fa-trash font-3xl mt-1 mr-3 pointer i-hover-danger" *ngIf="!disabled"
            (click)="deleteFile(file,form.value.id,idx)"></i>
        </div>
      </div>
    </form>
  </accordion-group>

</accordion>